import { baseApi } from "../redux/baseAPI";

export const appointmentApi = baseApi.injectEndpoints({
  tagTypes: ["PatientAppointments"],
  endpoints: (builder) => ({
    getPatientAppointment: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/appointments.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["PatientAppointments"],
    }),
    getChatGroupLocations: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_management/locations.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["ChatGroupLocations"],
    }),
    locationCheckin: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/checkin.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    locationCheckout: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/checkout.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getAppointmentsSlots: builder.query({
      query: (body) => {
        return {
          url: `/calendars/get_day_detail.json`,
          method: "GET",
          params: {
            start_date: body.start_date,
            provider: body.provider,
            location_id: body.location_id,
            pid: body.pid,
          },
        };
      },
      providesTags: ["AppointmentsSlots"],
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    addAppointments: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_appointments/add.json`,
        method: "POST",
        data: body.postData,
      }),
      transformResponse: (response, meta, arg) => response,
    }),
    addProviderAppointments: builder.mutation({
      query: (body) => ({
        url: `/appointments/add_appointment.json`,
        method: "POST",
        data: body.postData,
      }),
      transformResponse: (response, meta, arg) => response,
    }),
    getAppointmentsMeta: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_appointments/meta.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getAppointmentOptions: builder.query({
      query: (data) => {
        return {
          url: `/appointments/options_list.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getAppointmentById: builder.query({
      query: (data) => {
        return {
          url: `/appointments/getAppointmentById.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    notifyUserSetting: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/notify_user_for_urgent_message.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response?.response,
    }),
    updateCallSetting: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/update_call_flag_status.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response?.response,
    }),
    syncCheckinCheckout: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/sync_check_in_out.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response?.response,
    }),
    getAppointmentsOnCondition: builder.query({
      query: (payload) => {
        return {
          url: `/ccm/careplan.json`,
          method: "GET",
          params: {
            ...payload,
          },
        };
      },
      providesTags: ["AppointmentsOnCondition"],
      transformResponse: (response, meta, arg) => response.response.data,
    }),
  }),
});

export const {
  useGetPatientAppointmentQuery,
  useGetChatGroupLocationsQuery,
  useLocationCheckinMutation,
  useLocationCheckoutMutation,
  useGetAppointmentsSlotsQuery,
  useAddAppointmentsMutation,
  useAddProviderAppointmentsMutation,
  useGetAppointmentsMetaQuery,
  useGetAppointmentOptionsQuery,
  useGetAppointmentByIdQuery,
  useNotifyUserSettingMutation,
  useUpdateCallSettingMutation,
  useSyncCheckinCheckoutMutation,
  useGetAppointmentsOnConditionQuery,
} = appointmentApi;
